<template>
    <el-select v-model="selectedSiteId" v-loading="loading" @change="updateSelected">
        <el-option
                v-for="item in sites"
                :key="item.id"
                :label="item.nombre"
                :value="item.id"
        >
        </el-option>
    </el-select>
</template>

<script>
    import api from "../../utils/api/api";

    export default {
        name: "sitePicker",
        props: {
            onSiteSelected: {
                type: Function
            }
        },
        data: function () {
            return {
                loading: true,
                selectedSiteId: undefined,
                sites: []
            }
        },
        mounted() {
            api.getSites().then(value => {
                this.sites = value.sites;
                if (this.sites.length > 0) {
                    this.selectedSiteId = this.sites[0].id;
                    this.updateSelected(this.selectedSiteId);
                }

                this.loading = false;
            }).catch(reason => {
                console.error("Error al traer los establecimientos", reason);
                this.loading = false;
            })
        },
        methods: {
            updateSelected(selected) {
                let site = this.sites.find(value => {
                    return value.id === selected
                });

                if (this.onSiteSelected) {
                    this.onSiteSelected(site);
                }

            }
        }
    }
</script>

<style scoped>

</style>